import { Environment } from '@app/core/models';
import packageJson from '../package.json';


export const environment: Environment = {
  integrationPortalApi: {
    url: 'https://duravermeer-acc-apim.azure-api.net/integrationportalexperience',
    scope: '9f0da345-3159-4f3c-83c5-d4cf94f4e5ef/.default',
  },
  experienceApi: {
    url: 'https://duravermeer-acc-apim.azure-api.net/integrationportalexperience',
  },
  production: false,
  version: packageJson.version,
  clientId: '2298785b-a941-4999-ac21-bb790ed2123c',
  tenantId: '47ef05e2-eef7-412f-b794-3b99f6ab08e7',
};

